import React from 'react';

function CreatorsListView({
  creators,
  currentUserId,
  subscriptions,
  loading,
  onViewCreator,
  onSubscribe,
  onUnsubscribe
}) {
  const otherCreators = creators.filter(creator => creator.user_id !== currentUserId);
  
  return (
    <div className="space-y-4" data-testid="creators-view">
      <h2 className="text-2xl font-heading font-bold mb-4">Discover Foodies</h2>
      {otherCreators.length === 0 ? (
        <div className="bg-white rounded-card shadow-card p-8 text-center">
          <p className="text-gray-600 mb-2">No other creators yet</p>
          <p className="text-sm text-gray-500">Be the first to share your food recommendations!</p>
        </div>
      ) : (
        otherCreators.map(creator => {
        const subscription = subscriptions.find(sub => sub.creator.user_id === creator.user_id);
        const isSubscribed = !!subscription;
        
        const handleToggleSubscription = async () => {
          if (isSubscribed && subscription) {
            // Unsubscribe - show confirmation
            onUnsubscribe(subscription.subscription_id, creator.name, creator.user_id);
          } else {
            // Subscribe
            onSubscribe(creator.user_id);
          }
        };
        
        return (
          <div 
            key={creator.user_id} 
            className="bg-white rounded-card shadow-card p-4 cursor-pointer transition-all hover:shadow-hover hover:-translate-y-1"
            onClick={() => onViewCreator(creator.user_id)}
            data-testid={`creator-card-${creator.user_id}`}
          >
            <div className="flex items-start gap-4">
              {creator.picture ? (
                <img 
                  src={creator.picture} 
                  alt={creator.name}
                  className="w-16 h-16 rounded-full object-cover flex-shrink-0"
                />
              ) : (
                <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center text-white text-xl font-bold flex-shrink-0">
                  {creator.name?.charAt(0).toUpperCase()}
                </div>
              )}
              <div className="flex-1">
                <h3 className="font-heading font-bold text-lg hover:text-primary transition-colors">{creator.name}</h3>
                <p className="text-sm text-gray-600 mb-2">{creator.bio || 'Food enthusiast'}</p>
                <p className="text-xs text-gray-500">{creator.review_count} recommendations</p>
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevent card click when clicking button
                  handleToggleSubscription();
                }}
                disabled={loading}
                className={`px-4 py-2 rounded-button font-semibold text-sm whitespace-nowrap transition-all ${
                  isSubscribed 
                    ? 'bg-gray-200 text-gray-600 hover:bg-gray-300' 
                    : 'bg-primary text-white hover:shadow-hover'
                }`}
                data-testid={`subscribe-button-${creator.user_id}`}
              >
                {isSubscribed ? 'Subscribed' : 'Subscribe'}
              </button>
            </div>
          </div>
        );
      }))}
    </div>
  );
}

export default CreatorsListView;
